package com.cs.ejobin.i18n

typealias StringsMap = Map<String, String>

object Translations {

    fun forLang(lang: AppLanguage): StringsMap = when (lang) {
        AppLanguage.FR -> fr
        AppLanguage.EN -> en
        AppLanguage.PT -> pt
        AppLanguage.ES -> es
        AppLanguage.HT -> ht
    }

    private val fr = mapOf(
        Keys.description to "Description",
        Keys.description_placeholder to "Quelques mots sur toi (optionnel)",
        Keys.contact to "Contactez-nous",
        Keys.home to "Accueil",
        Keys.skill_chef to "Chef",
        Keys.skill_commis to "Commis",
        Keys.skill_salle to "Salle",
        Keys.skill_serveur to "Serveur",
        Keys.skill_chef_de_rang to "Chef de rang",
        Keys.skill_plongeur to "Plongeur",
        Keys.skill_caissier to "Caissier",
        Keys.skill_patissier to "Pâtissier",
        Keys.skill_pizzaiolo to "Pizzaiolo",
        Keys.skill_sous_chef to "Sous-chef",
        Keys.skill_sommelier to "Sommelier",
        Keys.skill_elagage to "Élagage",
        Keys.skill_ouvrier to "Ouvrier",
        Keys.skill_manoeuvre to "Manœuvre",
        Keys.skill_macon to "Maçon",
        Keys.skill_charpentier to "Charpentier",
        Keys.skill_menuisier to "Menuisier",
        Keys.skill_facadier_enduiseur to "Façadier / Enduiseur",
        Keys.skill_terrassier to "Terrassier",
        Keys.skill_conducteur_dengins to "Conducteur d’engins",
        Keys.skill_electricien to "Électricien",
        Keys.skill_plombier to "Plombier",
        Keys.skill_chauffagiste to "Chauffagiste",
        Keys.skill_climatisation to "Climatisation",
        Keys.skill_soudeur_metallier to "Soudeur métallier",
        Keys.skill_conducteur_de_travaux to "Conducteur de travaux",
        Keys.skill_ingenieur_btp to "Ingénieur BTP",
        Keys.skill_topographe to "Topographe",
        Keys.skill_etancheur to "Étancheur",
        Keys.skill_mecanicien to "Mécanicien",
        Keys.skill_peintre to "Peintre",
        Keys.skill_carreleur to "Carreleur",
        Keys.skill_cordiste to "Cordiste",
        Keys.skill_chef_de_chantier to "Chef de chantier",
        Keys.skill_coffreur_bancheur to "Coffreur / Bancheur",
        Keys.skill_receptionniste to "Réceptionniste",
        Keys.skill_voiturier to "Voiturier",
        Keys.skill_standardiste to "Standardiste",
        Keys.skill_concierge to "Concierge",
        Keys.skill_bagagiste to "Bagagiste",
        Keys.skill_valet_de_chambre to "Valet de chambre",
        Keys.skill_gouvernante to "Gouvernante",
        Keys.skill_equipier_detages to "Équipier d’étages",
        Keys.skill_bien_etre to "Bien-être",
        Keys.skill_polyvalent to "Polyvalent",
        Keys.skill_coursier to "Coursier",
        Keys.skill_livreur to "Livreur",
        Keys.home_tagline to "Trouvez votre job en moins de 24h et commencez aujourd’hui",
        Keys.footer_made_by to "Site réalisé par SBH AI DEVELOPMENT",
        Keys.legal_title to "Documents",
        Keys.accept_label to "J’ai lu et j’accepte les documents ci-dessus",
        Keys.accept_required to "Tu dois accepter les documents pour continuer.",
        Keys.doc_terms_title to "SOP – Gestion des incidents & litiges",
        Keys.doc_privacy_title to "Politique anti no-show & annulation",
        Keys.doc_cookies_title to "Politique de paiement & flux financiers",
        Keys.doc_subscription_title to "Charte des engagements réciproques",
        Keys.doc_legal_notice_title to "Politique de preuve & conservation des données",
        Keys.cancel_subscription to "Résilier l’abonnement",
        Keys.cancel_subscription_confirm_title to "Confirmer la résiliation",
        Keys.cancel_subscription_confirm_body to "Ton abonnement restera actif jusqu’à la fin de la période en cours. Tu pourras te réabonner à tout moment.",
        Keys.cancel_subscription_confirm_cta to "Résilier",
        Keys.cancel_subscription_keep to "Garder mon abonnement",
        Keys.cancel_subscription_error to "Impossible de résilier pour le moment. Réessaie plus tard.",
        Keys.forgot_subtitle to "Entre ton email et on t’envoie un lien de réinitialisation.",
        Keys.forgot_send_link to "Envoyer le lien",
        Keys.forgot_back to "Retour",
        Keys.forgot_sent_title to "Email envoyé",
        Keys.forgot_sent_body to "Ouvre le lien reçu pour définir ton nouveau mot de passe.",
        Keys.forgot_continue to "Continuer",
        Keys.reset_subtitle to "Choisis un mot de passe sécurisé.",
        Keys.paywall_title to "Abonnement",
        Keys.paywall_headline to "Accède à l’annuaire complet",
        Keys.paywall_subtitle to "Débloque tous les profils et filtre par compétences.",
        Keys.paywall_cta to "Choisir",
        Keys.paywall_plan_monthly_hint to "1 mois d’essai gratuit, puis 9,90€ / mois.",
        Keys.paywall_plan_yearly_hint to "99,90€ / an (2 mois offerts).",
        Keys.checkout_success_title to "Paiement confirmé",
        Keys.checkout_success_headline to "Merci !",
        Keys.checkout_success_body to "Ton abonnement est actif. Tu peux maintenant accéder à tout l’annuaire.",
        Keys.checkout_success_continue to "Continuer",
        Keys.checkout_success_profile to "Voir mon profil",
        Keys.checkout_cancel_title to "Paiement annulé",
        Keys.checkout_cancel_headline to "Paiement interrompu",
        Keys.checkout_cancel_body to "Aucun paiement n’a été effectué. Tu peux réessayer quand tu veux.",
        Keys.checkout_cancel_back_home to "Retour à l’accueil",
        Keys.checkout_cancel_profile to "Voir mon profil",
        Keys.paywall_features_title to "Inclus",
        Keys.paywall_feature_1 to "Accès illimité à l’annuaire",
        Keys.paywall_feature_2 to "Voir les profils complets (photo, compétences, téléphone)",
        Keys.paywall_feature_3 to "Mises à jour automatiques de ton abonnement",
        Keys.paywall_choose_plan to "Choisis ton offre",
        Keys.paywall_plan_monthly to "Mensuel",
        Keys.paywall_plan_yearly to "Annuel",
        Keys.paywall_not_now to "Plus tard",
        Keys.paywall_disclaimer to "Le paiement est géré par Stripe. Tu peux annuler à tout moment.",
        Keys.show_more to "Afficher plus",
        Keys.show_less to "Afficher moins",
        Keys.not_connected to "Non connecté.",
        Keys.email_label to "Email :",
        Keys.subscription_status to "Statut :",
        Keys.subscription_none to "Aucun abonnement actif",
        Keys.subscription_active to "Abonnement actif",
        Keys.subscription_expired to "Abonnement expiré",
        Keys.subscription_required_title to "Abonnement requis",
        Keys.subscription_required_body to "Un abonnement est nécessaire pour accéder à l’annuaire.",
        Keys.search_placeholder to "Rechercher un extra",
        Keys.filters to "Filtres",
        Keys.directory_locked_item_title to "Accès limité",
        Keys.directory_locked_item_body to "Les détails sont masqués sans abonnement.",
        Keys.retry to "Réessayer",
        Keys.no_results_title to "Aucun résultat",
        Keys.no_results_body to "Aucun extra ne correspond à ta recherche.",
        Keys.clear_filters to "Effacer les filtres",
        Keys.signup_subtitle to "Crée ton compte et commence à travailler rapidement",
        Keys.already_have_account to "J’ai déjà un compte",
        Keys.login_subtitle to "Accède à ton espace eJobin gratuitement",
        Keys.login to "Se connecter",
        Keys.loading to "Chargement…",
        Keys.show to "Afficher",
        Keys.hide to "Masquer",
        Keys.error_generic to "Erreur",
        Keys.login_title to "Connexion",
        Keys.signup_title to "Inscription",
        Keys.forgot_title to "Mot de passe oublié",
        Keys.otp_title to "Vérification",
        Keys.reset_title to "Nouveau mot de passe",
        Keys.email to "Email",
        Keys.phone to "Numéro de téléphone",
        Keys.password to "Mot de passe",
        Keys.password_confirm to "Confirmation du mot de passe",
        Keys.name to "Nom",
        Keys.create_account to "Créer un compte",
        Keys.forgot_password to "Mot de passe oublié",
        Keys.send_link to "Envoyer le lien",
        Keys.sending to "Envoi...",
        Keys.update_password to "Mettre à jour le mot de passe",
        Keys.updating to "Mise à jour...",
        Keys.otp_help to "Un lien de vérification a été envoyé. Clique sur le lien reçu par email pour continuer.",
        Keys.otp_i_clicked to "J’ai cliqué sur le lien",
        Keys.see_offers to "Voir les offres",
        Keys.search to "Rechercher",
        Keys.available to "Disponible",
        Keys.unavailable to "Indisponible",
        Keys.extra_title to "Fiche extra",
        Keys.phone_label to "Téléphone :",
        Keys.profile_title to "Profil",
        Keys.logout to "Déconnexion",
        Keys.save to "Enregistrer",
        Keys.saving to "Enregistrement...",
        Keys.refresh to "Actualiser",
        Keys.pick_photo to "Choisir une photo",
        Keys.skills_jobs to "Métiers / compétences",
        Keys.required_email to "Email requis.",
        Keys.required_name to "Nom requis.",
        Keys.invalid_phone to "Numéro de téléphone invalide.",
        Keys.weak_password to "Mot de passe trop court (min 6).",
        Keys.password_mismatch to "Les mots de passe ne correspondent pas.",
        Keys.select_one_skill to "Sélectionne au moins une compétence.",
    )

    private val en = mapOf(
        Keys.description to "Description",
        Keys.description_placeholder to "A few words about you (optional)",
        Keys.contact to "Contact us",
        Keys.home to "Home",
        Keys.skill_chef to "Chef",
        Keys.skill_commis to "Kitchen assistant",
        Keys.skill_salle to "Dining room staff",
        Keys.skill_serveur to "Waiter",
        Keys.skill_chef_de_rang to "Head waiter",
        Keys.skill_plongeur to "Dishwasher",
        Keys.skill_caissier to "Cashier",
        Keys.skill_patissier to "Pastry chef",
        Keys.skill_pizzaiolo to "Pizzaiolo",
        Keys.skill_sous_chef to "Sous-chef",
        Keys.skill_sommelier to "Sommelier",
        Keys.skill_elagage to "Tree pruning",
        Keys.skill_ouvrier to "Worker",
        Keys.skill_manoeuvre to "Laborer",
        Keys.skill_macon to "Mason",
        Keys.skill_charpentier to "Carpenter",
        Keys.skill_menuisier to "Joiner",
        Keys.skill_facadier_enduiseur to "Facade plasterer",
        Keys.skill_terrassier to "Earthworks worker",
        Keys.skill_conducteur_dengins to "Heavy machinery operator",
        Keys.skill_electricien to "Electrician",
        Keys.skill_plombier to "Plumber",
        Keys.skill_chauffagiste to "Heating technician",
        Keys.skill_climatisation to "Air conditioning technician",
        Keys.skill_soudeur_metallier to "Metal welder",
        Keys.skill_conducteur_de_travaux to "Construction manager",
        Keys.skill_ingenieur_btp to "Civil engineer",
        Keys.skill_topographe to "Surveyor",
        Keys.skill_etancheur to "Waterproofer",
        Keys.skill_mecanicien to "Mechanic",
        Keys.skill_peintre to "Painter",
        Keys.skill_carreleur to "Tiler",
        Keys.skill_cordiste to "Rope access technician",
        Keys.skill_chef_de_chantier to "Site foreman",
        Keys.skill_coffreur_bancheur to "Formwork carpenter",
        Keys.skill_receptionniste to "Receptionist",
        Keys.skill_voiturier to "Valet",
        Keys.skill_standardiste to "Switchboard operator",
        Keys.skill_concierge to "Concierge",
        Keys.skill_bagagiste to "Porter",
        Keys.skill_valet_de_chambre to "Room attendant",
        Keys.skill_gouvernante to "Housekeeper",
        Keys.skill_equipier_detages to "Floor attendant",
        Keys.skill_bien_etre to "Wellness",
        Keys.skill_polyvalent to "Multi-skilled",
        Keys.skill_coursier to "Courier",
        Keys.skill_livreur to "Delivery driver",
        Keys.home_tagline to "Find a job in under 24 hours and start today",
        Keys.footer_made_by to "Website developed by SBH AI DEVELOPMENT",
        Keys.legal_title to "Documents",
        Keys.accept_label to "I have read and accept the documents above",
        Keys.accept_required to "You must accept the documents to continue.",
        Keys.doc_terms_title to "SOP – Incident & Dispute Management",
        Keys.doc_privacy_title to "No-show & Cancellation Policy",
        Keys.doc_cookies_title to "Payment & Financial Flow Policy",
        Keys.doc_subscription_title to "Mutual Commitments Charter",
        Keys.doc_legal_notice_title to "Evidence & Data Retention Policy",
        Keys.cancel_subscription to "Cancel subscription",
        Keys.cancel_subscription_confirm_title to "Confirm cancellation",
        Keys.cancel_subscription_confirm_body to "Your subscription will stay active until the end of the current period. You can resubscribe anytime.",
        Keys.cancel_subscription_confirm_cta to "Cancel",
        Keys.cancel_subscription_keep to "Keep my subscription",
        Keys.cancel_subscription_error to "Unable to cancel right now. Please try again later.",
        Keys.forgot_subtitle to "Enter your email and we’ll send you a reset link.",
        Keys.forgot_send_link to "Send link",
        Keys.forgot_back to "Back",
        Keys.forgot_sent_title to "Email sent",
        Keys.forgot_sent_body to "Open the link you received to set your new password.",
        Keys.forgot_continue to "Continue",
        Keys.reset_subtitle to "Choose a secure password.",
        Keys.paywall_title to "Subscription",
        Keys.paywall_headline to "Get full directory access",
        Keys.paywall_subtitle to "Unlock all profiles and filter by skills.",
        Keys.paywall_cta to "Choose",
        Keys.paywall_plan_monthly_hint to "1 month free trial, then €9.90 per month.",
        Keys.paywall_plan_yearly_hint to "€99.90 per year (2 months free).",
        Keys.checkout_success_title to "Payment confirmed",
        Keys.checkout_success_headline to "Thank you!",
        Keys.checkout_success_body to "Your subscription is active. You can now access the full directory.",
        Keys.checkout_success_continue to "Continue",
        Keys.checkout_success_profile to "View my profile",
        Keys.checkout_cancel_title to "Payment canceled",
        Keys.checkout_cancel_headline to "Payment stopped",
        Keys.checkout_cancel_body to "No payment was made. You can try again anytime.",
        Keys.checkout_cancel_back_home to "Back to home",
        Keys.checkout_cancel_profile to "View my profile",
        Keys.paywall_features_title to "Included",
        Keys.paywall_feature_1 to "Unlimited directory access",
        Keys.paywall_feature_2 to "See full profiles (photo, skills, phone)",
        Keys.paywall_feature_3 to "Automatic subscription updates",
        Keys.paywall_choose_plan to "Choose a plan",
        Keys.paywall_plan_monthly to "Monthly",
        Keys.paywall_plan_yearly to "Yearly",
        Keys.paywall_not_now to "Not now",
        Keys.paywall_disclaimer to "Payments are handled by Stripe. You can cancel anytime.",
        Keys.show_more to "Show more",
        Keys.show_less to "Show less",
        Keys.not_connected to "Not signed in.",
        Keys.email_label to "Email:",
        Keys.subscription_status to "Status:",
        Keys.subscription_none to "No active subscription",
        Keys.subscription_active to "Active subscription",
        Keys.subscription_expired to "Expired subscription",
        Keys.subscription_required_title to "Subscription required",
        Keys.subscription_required_body to "A subscription is required to access the directory.",
        Keys.search_placeholder to "Search for a worker",
        Keys.filters to "Filters",
        Keys.directory_locked_item_title to "Limited access",
        Keys.directory_locked_item_body to "Details are hidden without a subscription.",
        Keys.retry to "Retry",
        Keys.no_results_title to "No results",
        Keys.no_results_body to "No workers match your search.",
        Keys.clear_filters to "Clear filters",
        Keys.signup_subtitle to "Create your account and start working quickly",
        Keys.already_have_account to "I already have an account",
        Keys.login_subtitle to "Access your eJobin space for free",
        Keys.login to "Sign in",
        Keys.loading to "Loading…",
        Keys.show to "Show",
        Keys.hide to "Hide",
        Keys.error_generic to "Error",
        Keys.login_title to "Sign in",
        Keys.signup_title to "Sign up",
        Keys.forgot_title to "Forgot password",
        Keys.otp_title to "Verification",
        Keys.reset_title to "New password",
        Keys.email to "Email",
        Keys.phone to "Phone number",
        Keys.password to "Password",
        Keys.password_confirm to "Confirm password",
        Keys.name to "Name",
        Keys.create_account to "Create an account",
        Keys.forgot_password to "Forgot password",
        Keys.send_link to "Send link",
        Keys.sending to "Sending...",
        Keys.update_password to "Update password",
        Keys.updating to "Updating...",
        Keys.otp_help to "A verification link was sent. Click the link in your email to continue.",
        Keys.otp_i_clicked to "I clicked the link",
        Keys.see_offers to "See offers",
        Keys.search to "Search",
        Keys.available to "Available",
        Keys.unavailable to "Unavailable",
        Keys.extra_title to "Extra profile",
        Keys.phone_label to "Phone:",
        Keys.profile_title to "Profile",
        Keys.logout to "Log out",
        Keys.save to "Save",
        Keys.saving to "Saving...",
        Keys.refresh to "Refresh",
        Keys.pick_photo to "Choose photo",
        Keys.skills_jobs to "Jobs / skills",
        Keys.required_email to "Email is required.",
        Keys.required_name to "Name is required.",
        Keys.invalid_phone to "Invalid phone number.",
        Keys.weak_password to "Password too short (min 6).",
        Keys.password_mismatch to "Passwords do not match.",
        Keys.select_one_skill to "Select at least one skill.",
    )

    private val pt = mapOf(
        Keys.description to "Descrição",
        Keys.description_placeholder to "Algumas palavras sobre você (opcional)",
        Keys.contact to "Contacte-nos",
        Keys.home to "Início",
        Keys.skill_chef to "Chef",
        Keys.skill_commis to "Ajudante de cozinha",
        Keys.skill_salle to "Sala",
        Keys.skill_serveur to "Garçom",
        Keys.skill_chef_de_rang to "Chefe de sala",
        Keys.skill_plongeur to "Lavador de louça",
        Keys.skill_caissier to "Caixa",
        Keys.skill_patissier to "Confeiteiro",
        Keys.skill_pizzaiolo to "Pizzaiolo",
        Keys.skill_sous_chef to "Subchefe",
        Keys.skill_sommelier to "Sommelier",
        Keys.skill_elagage to "Poda",
        Keys.skill_ouvrier to "Operário",
        Keys.skill_manoeuvre to "Ajudante",
        Keys.skill_macon to "Pedreiro",
        Keys.skill_charpentier to "Carpinteiro",
        Keys.skill_menuisier to "Marceneiro",
        Keys.skill_facadier_enduiseur to "Fachadeiro / Rebocador",
        Keys.skill_terrassier to "Terraplenista",
        Keys.skill_conducteur_dengins to "Operador de máquinas",
        Keys.skill_electricien to "Eletricista",
        Keys.skill_plombier to "Encanador",
        Keys.skill_chauffagiste to "Técnico de aquecimento",
        Keys.skill_climatisation to "Climatização",
        Keys.skill_soudeur_metallier to "Soldador",
        Keys.skill_conducteur_de_travaux to "Encarregado de obras",
        Keys.skill_ingenieur_btp to "Engenheiro civil",
        Keys.skill_topographe to "Topógrafo",
        Keys.skill_etancheur to "Impermeabilizador",
        Keys.skill_mecanicien to "Mecânico",
        Keys.skill_peintre to "Pintor",
        Keys.skill_carreleur to "Azulejista",
        Keys.skill_cordiste to "Técnico de acesso por corda",
        Keys.skill_chef_de_chantier to "Chefe de obra",
        Keys.skill_coffreur_bancheur to "Carpinteiro de formas",
        Keys.skill_receptionniste to "Recepcionista",
        Keys.skill_voiturier to "Manobrista",
        Keys.skill_standardiste to "Telefonista",
        Keys.skill_concierge to "Concierge",
        Keys.skill_bagagiste to "Carregador de bagagens",
        Keys.skill_valet_de_chambre to "Camareiro",
        Keys.skill_gouvernante to "Governanta",
        Keys.skill_equipier_detages to "Auxiliar de andares",
        Keys.skill_bien_etre to "Bem-estar",
        Keys.skill_polyvalent to "Polivalente",
        Keys.skill_coursier to "Mensageiro",
        Keys.skill_livreur to "Entregador",
        Keys.home_tagline to "Encontre um emprego em menos de 24 horas e comece hoje",
        Keys.footer_made_by to "Site desenvolvido por SBH AI DEVELOPMENT",
        Keys.legal_title to "Documentos",
        Keys.accept_label to "Li e aceito os documentos acima",
        Keys.accept_required to "Você deve aceitar os documentos para continuar.",
        Keys.doc_terms_title to "SOP – Gestão de incidentes e litígios",
        Keys.doc_privacy_title to "Política de não comparecimento e cancelamento",
        Keys.doc_cookies_title to "Política de pagamento e fluxos financeiros",
        Keys.doc_subscription_title to "Carta de compromissos recíprocos",
        Keys.doc_legal_notice_title to "Política de prova e conservação de dados",
        Keys.cancel_subscription to "Cancelar assinatura",
        Keys.cancel_subscription_confirm_title to "Confirmar cancelamento",
        Keys.cancel_subscription_confirm_body to "Sua assinatura continuará ativa até o fim do período atual. Você pode assinar novamente a qualquer momento.",
        Keys.cancel_subscription_confirm_cta to "Cancelar",
        Keys.cancel_subscription_keep to "Manter minha assinatura",
        Keys.cancel_subscription_error to "Não foi possível cancelar agora. Tente novamente mais tarde.",
        Keys.forgot_subtitle to "Insere o teu email e vamos enviar um link de redefinição.",
        Keys.forgot_send_link to "Enviar link",
        Keys.forgot_back to "Voltar",
        Keys.forgot_sent_title to "Email enviado",
        Keys.forgot_sent_body to "Abre o link recebido para definir a tua nova palavra-passe.",
        Keys.forgot_continue to "Continuar",
        Keys.reset_subtitle to "Escolhe uma palavra-passe segura.",
        Keys.paywall_title to "Assinatura",
        Keys.paywall_headline to "Acede ao diretório completo",
        Keys.paywall_subtitle to "Desbloqueia todos os perfis e filtra por competências.",
        Keys.paywall_cta to "Escolher",
        Keys.paywall_plan_monthly_hint to "1 mês de teste grátis, depois 9,90€ por mês.",
        Keys.paywall_plan_yearly_hint to "99,90€ por ano (2 meses grátis).",
        Keys.checkout_success_title to "Pagamento confirmado",
        Keys.checkout_success_headline to "Obrigado!",
        Keys.checkout_success_body to "A tua assinatura está ativa. Já podes aceder ao diretório completo.",
        Keys.checkout_success_continue to "Continuar",
        Keys.checkout_success_profile to "Ver o meu perfil",
        Keys.checkout_cancel_title to "Pagamento cancelado",
        Keys.checkout_cancel_headline to "Pagamento interrompido",
        Keys.checkout_cancel_body to "Nenhum pagamento foi efetuado. Podes tentar novamente quando quiseres.",
        Keys.checkout_cancel_back_home to "Voltar ao início",
        Keys.checkout_cancel_profile to "Ver o meu perfil",
        Keys.paywall_features_title to "Inclui",
        Keys.paywall_feature_1 to "Acesso ilimitado ao diretório",
        Keys.paywall_feature_2 to "Ver perfis completos (foto, skills, telefone)",
        Keys.paywall_feature_3 to "Atualização automática da sua assinatura",
        Keys.paywall_choose_plan to "Escolha um plano",
        Keys.paywall_plan_monthly to "Mensal",
        Keys.paywall_plan_yearly to "Anual",
        Keys.paywall_not_now to "Agora não",
        Keys.paywall_disclaimer to "Pagamentos via Stripe. Você pode cancelar a qualquer momento.",
        Keys.show_more to "Mostrar mais",
        Keys.show_less to "Mostrar menos",
        Keys.not_connected to "Não conectado.",
        Keys.email_label to "E-mail:",
        Keys.subscription_status to "Estado:",
        Keys.subscription_none to "Sem assinatura ativa",
        Keys.subscription_active to "Assinatura ativa",
        Keys.subscription_expired to "Assinatura expirada",
        Keys.subscription_required_title to "Assinatura necessária",
        Keys.subscription_required_body to "É necessária uma assinatura para acessar o diretório.",
        Keys.search_placeholder to "Pesquisar profissional",
        Keys.filters to "Filtros",
        Keys.directory_locked_item_title to "Acesso limitado",
        Keys.directory_locked_item_body to "Os detalhes estão ocultos sem assinatura.",
        Keys.retry to "Tentar novamente",
        Keys.no_results_title to "Nenhum resultado",
        Keys.no_results_body to "Nenhum profissional corresponde à sua pesquisa.",
        Keys.clear_filters to "Limpar filtros",
        Keys.signup_subtitle to "Cria a tua conta e começa a trabalhar rapidamente",
        Keys.already_have_account to "Já tenho uma conta",
        Keys.login_subtitle to "Acede ao teu espaço eJobin gratuitamente",
        Keys.login to "Entrar",
        Keys.loading to "Carregando…",
        Keys.show to "Mostrar",
        Keys.hide to "Ocultar",
        Keys.error_generic to "Erro",
        Keys.login_title to "Entrar",
        Keys.signup_title to "Criar conta",
        Keys.forgot_title to "Esqueci a senha",
        Keys.otp_title to "Verificação",
        Keys.reset_title to "Nova senha",
        Keys.email to "Email",
        Keys.phone to "Número de telefone",
        Keys.password to "Senha",
        Keys.password_confirm to "Confirmar senha",
        Keys.name to "Nome",
        Keys.create_account to "Criar uma conta",
        Keys.forgot_password to "Esqueci a senha",
        Keys.send_link to "Enviar link",
        Keys.sending to "Enviando...",
        Keys.update_password to "Atualizar senha",
        Keys.updating to "Atualizando...",
        Keys.otp_help to "Um link de verificação foi enviado. Clique no link do email para continuar.",
        Keys.otp_i_clicked to "Cliquei no link",
        Keys.see_offers to "Ver ofertas",
        Keys.search to "Pesquisar",
        Keys.available to "Disponível",
        Keys.unavailable to "Indisponível",
        Keys.extra_title to "Perfil",
        Keys.phone_label to "Telefone:",
        Keys.profile_title to "Perfil",
        Keys.logout to "Sair",
        Keys.save to "Salvar",
        Keys.saving to "Salvando...",
        Keys.refresh to "Atualizar",
        Keys.pick_photo to "Escolher foto",
        Keys.skills_jobs to "Trabalhos / habilidades",
        Keys.required_email to "Email obrigatório.",
        Keys.required_name to "Nome obrigatório.",
        Keys.invalid_phone to "Número de telefone inválido.",
        Keys.weak_password to "Senha muito curta (mín 6).",
        Keys.password_mismatch to "As senhas não coincidem.",
        Keys.select_one_skill to "Selecione pelo menos uma habilidade.",
    )

    private val es = mapOf(
        Keys.description to "Descripción",
        Keys.description_placeholder to "Unas palabras sobre ti (opcional)",
        Keys.contact to "Contáctanos",
        Keys.home to "Inicio",
        Keys.skill_chef to "Chef",
        Keys.skill_commis to "Ayudante de cocina",
        Keys.skill_salle to "Sala",
        Keys.skill_serveur to "Camarero",
        Keys.skill_chef_de_rang to "Jefe de rango",
        Keys.skill_plongeur to "Friegaplatos",
        Keys.skill_caissier to "Cajero",
        Keys.skill_patissier to "Pastelero",
        Keys.skill_pizzaiolo to "Pizzero",
        Keys.skill_sous_chef to "Segundo de cocina",
        Keys.skill_sommelier to "Sumiller",
        Keys.skill_elagage to "Poda",
        Keys.skill_ouvrier to "Obrero",
        Keys.skill_manoeuvre to "Peón",
        Keys.skill_macon to "Albañil",
        Keys.skill_charpentier to "Carpintero",
        Keys.skill_menuisier to "Ebanista",
        Keys.skill_facadier_enduiseur to "Fachadista / Enlucidor",
        Keys.skill_terrassier to "Operario de movimiento de tierras",
        Keys.skill_conducteur_dengins to "Maquinista",
        Keys.skill_electricien to "Electricista",
        Keys.skill_plombier to "Fontanero",
        Keys.skill_chauffagiste to "Técnico de calefacción",
        Keys.skill_climatisation to "Climatización",
        Keys.skill_soudeur_metallier to "Soldador metalista",
        Keys.skill_conducteur_de_travaux to "Jefe de obra",
        Keys.skill_ingenieur_btp to "Ingeniero de construcción",
        Keys.skill_topographe to "Topógrafo",
        Keys.skill_etancheur to "Impermeabilizador",
        Keys.skill_mecanicien to "Mecánico",
        Keys.skill_peintre to "Pintor",
        Keys.skill_carreleur to "Alicatador",
        Keys.skill_cordiste to "Técnico de trabajos verticales",
        Keys.skill_chef_de_chantier to "Encargado de obra",
        Keys.skill_coffreur_bancheur to "Encofrador",
        Keys.skill_receptionniste to "Recepcionista",
        Keys.skill_voiturier to "Aparcacoches",
        Keys.skill_standardiste to "Telefonista",
        Keys.skill_concierge to "Conserje",
        Keys.skill_bagagiste to "Botones",
        Keys.skill_valet_de_chambre to "Camarero/a de pisos",
        Keys.skill_gouvernante to "Gobernanta",
        Keys.skill_equipier_detages to "Auxiliar de pisos",
        Keys.skill_bien_etre to "Bienestar",
        Keys.skill_polyvalent to "Polivalente",
        Keys.skill_coursier to "Mensajero",
        Keys.skill_livreur to "Repartidor",
        Keys.home_tagline to "Encuentra un trabajo en menos de 24 horas y empieza hoy",
        Keys.footer_made_by to "Sitio web desarrollado por SBH AI DEVELOPMENT",
        Keys.legal_title to "Documentos",
        Keys.accept_label to "He leído y acepto los documentos anteriores",
        Keys.accept_required to "Debes aceptar los documentos para continuar.",
        Keys.doc_terms_title to "SOP – Gestión de incidentes y disputas",
        Keys.doc_privacy_title to "Política de no presentación y cancelación",
        Keys.doc_cookies_title to "Política de pagos y flujos financieros",
        Keys.doc_subscription_title to "Carta de compromisos recíprocos",
        Keys.doc_legal_notice_title to "Política de prueba y conservación de datos",
        Keys.cancel_subscription to "Cancelar suscripción",
        Keys.cancel_subscription_confirm_title to "Confirmar cancelación",
        Keys.cancel_subscription_confirm_body to "Tu suscripción seguirá activa hasta el final del período actual. Puedes volver a suscribirte en cualquier momento.",
        Keys.cancel_subscription_confirm_cta to "Cancelar",
        Keys.cancel_subscription_keep to "Mantener mi suscripción",
        Keys.cancel_subscription_error to "No se pudo cancelar en este momento. Inténtalo de nuevo más tarde.",
        Keys.forgot_subtitle to "Introduce tu correo y te enviaremos un enlace para restablecer.",
        Keys.forgot_send_link to "Enviar enlace",
        Keys.forgot_back to "Volver",
        Keys.forgot_sent_title to "Correo enviado",
        Keys.forgot_sent_body to "Abre el enlace recibido para establecer tu nueva contraseña.",
        Keys.forgot_continue to "Continuar",
        Keys.reset_subtitle to "Elige una contraseña segura.",
        Keys.paywall_title to "Suscripción",
        Keys.paywall_headline to "Accede al directorio completo",
        Keys.paywall_subtitle to "Desbloquea todos los perfiles y filtra por habilidades.",
        Keys.paywall_cta to "Elegir",
        Keys.paywall_plan_monthly_hint to "1 mes de prueba gratis, luego 9,90€ al mes.",
        Keys.paywall_plan_yearly_hint to "99,90€ al año (2 meses gratis).",
        Keys.checkout_success_title to "Pago confirmado",
        Keys.checkout_success_headline to "¡Gracias!",
        Keys.checkout_success_body to "Tu suscripción está activa. Ya puedes acceder al directorio completo.",
        Keys.checkout_success_continue to "Continuar",
        Keys.checkout_success_profile to "Ver mi perfil",
        Keys.checkout_cancel_title to "Pago cancelado",
        Keys.checkout_cancel_headline to "Pago interrumpido",
        Keys.checkout_cancel_body to "No se realizó ningún pago. Puedes intentarlo de nuevo cuando quieras.",
        Keys.checkout_cancel_back_home to "Volver al inicio",
        Keys.checkout_cancel_profile to "Ver mi perfil",
        Keys.paywall_features_title to "Incluye",
        Keys.paywall_feature_1 to "Acceso ilimitado al directorio",
        Keys.paywall_feature_2 to "Ver perfiles completos (foto, habilidades, teléfono)",
        Keys.paywall_feature_3 to "Actualización automática de tu suscripción",
        Keys.paywall_choose_plan to "Elige tu plan",
        Keys.paywall_plan_monthly to "Mensual",
        Keys.paywall_plan_yearly to "Anual",
        Keys.paywall_not_now to "Más tarde",
        Keys.paywall_disclaimer to "El pago se gestiona con Stripe. Puedes cancelar cuando quieras.",
        Keys.show_more to "Mostrar más",
        Keys.show_less to "Mostrar menos",
        Keys.not_connected to "No conectado.",
        Keys.email_label to "Correo:",
        Keys.subscription_status to "Estado:",
        Keys.subscription_none to "Sin suscripción activa",
        Keys.subscription_active to "Suscripción activa",
        Keys.subscription_expired to "Suscripción caducada",
        Keys.subscription_required_title to "Suscripción requerida",
        Keys.subscription_required_body to "Se requiere una suscripción para acceder al directorio.",
        Keys.search_placeholder to "Buscar profesional",
        Keys.filters to "Filtros",
        Keys.directory_locked_item_title to "Acceso limitado",
        Keys.directory_locked_item_body to "Los detalles están ocultos sin suscripción.",
        Keys.retry to "Reintentar",
        Keys.no_results_title to "Sin resultados",
        Keys.no_results_body to "No hay profesionales que coincidan con tu búsqueda.",
        Keys.clear_filters to "Borrar filtros",
        Keys.signup_subtitle to "Crea tu cuenta y empieza a trabajar rápidamente",
        Keys.already_have_account to "Ya tengo una cuenta",
        Keys.login_subtitle to "Accede a tu espacio eJobin gratis",
        Keys.login to "Iniciar sesión",
        Keys.loading to "Cargando…",
        Keys.show to "Mostrar",
        Keys.hide to "Ocultar",
        Keys.error_generic to "Error",
        Keys.login_title to "Iniciar sesión",
        Keys.signup_title to "Registrarse",
        Keys.forgot_title to "Olvidé mi contraseña",
        Keys.otp_title to "Verificación",
        Keys.reset_title to "Nueva contraseña",
        Keys.email to "Email",
        Keys.phone to "Número de teléfono",
        Keys.password to "Contraseña",
        Keys.password_confirm to "Confirmar contraseña",
        Keys.name to "Nombre",
        Keys.create_account to "Crear una cuenta",
        Keys.forgot_password to "Olvidé mi contraseña",
        Keys.send_link to "Enviar enlace",
        Keys.sending to "Enviando...",
        Keys.update_password to "Actualizar contraseña",
        Keys.updating to "Actualizando...",
        Keys.otp_help to "Se envió un enlace de verificación. Haz clic en el enlace del email para continuar.",
        Keys.otp_i_clicked to "He hecho clic en el enlace",
        Keys.see_offers to "Ver ofertas",
        Keys.search to "Buscar",
        Keys.available to "Disponible",
        Keys.unavailable to "No disponible",
        Keys.extra_title to "Perfil",
        Keys.phone_label to "Teléfono:",
        Keys.profile_title to "Perfil",
        Keys.logout to "Cerrar sesión",
        Keys.save to "Guardar",
        Keys.saving to "Guardando...",
        Keys.refresh to "Actualizar",
        Keys.pick_photo to "Elegir foto",
        Keys.skills_jobs to "Trabajos / habilidades",
        Keys.required_email to "Email requerido.",
        Keys.required_name to "Nombre requerido.",
        Keys.invalid_phone to "Número de teléfono inválido.",
        Keys.weak_password to "Contraseña demasiado corta (mín 6).",
        Keys.password_mismatch to "Las contraseñas no coinciden.",
        Keys.select_one_skill to "Selecciona al menos una habilidad.",
    )

    private val ht = mapOf(
        Keys.description to "Deskripsyon",
        Keys.description_placeholder to "Kèk mo sou ou (opsyonèl)",
        Keys.contact to "Kontakte nou",
        Keys.home to "Akèy",
        Keys.skill_chef to "Chèf",
        Keys.skill_commis to "Asistan kwizin",
        Keys.skill_salle to "Sèvis sal",
        Keys.skill_serveur to "Sèvitè",
        Keys.skill_chef_de_rang to "Chèf sèvitè",
        Keys.skill_plongeur to "Lave-aswèt",
        Keys.skill_caissier to "Kasye",
        Keys.skill_patissier to "Patisye",
        Keys.skill_pizzaiolo to "Pizayòl",
        Keys.skill_sous_chef to "Sou-chèf",
        Keys.skill_sommelier to "Somelye",
        Keys.skill_elagage to "Koupe pyebwa",
        Keys.skill_ouvrier to "Ouvriye",
        Keys.skill_manoeuvre to "Manèv",
        Keys.skill_macon to "Mason",
        Keys.skill_charpentier to "Chapantye",
        Keys.skill_menuisier to "Bòs mèb",
        Keys.skill_facadier_enduiseur to "Plastrè fasad",
        Keys.skill_terrassier to "Travay tè",
        Keys.skill_conducteur_dengins to "Operatè machin lou",
        Keys.skill_electricien to "Elektrisyen",
        Keys.skill_plombier to "Plonbye",
        Keys.skill_chauffagiste to "Teknisyen chofaj",
        Keys.skill_climatisation to "Klimatizasyon",
        Keys.skill_soudeur_metallier to "Soudeur metal",
        Keys.skill_conducteur_de_travaux to "Chèf travay",
        Keys.skill_ingenieur_btp to "Enjenyè konstriksyon",
        Keys.skill_topographe to "Topograf",
        Keys.skill_etancheur to "Teknisyen enpèmeyab",
        Keys.skill_mecanicien to "Mekanis",
        Keys.skill_peintre to "Pentr",
        Keys.skill_carreleur to "Pozè karo",
        Keys.skill_cordiste to "Teknisyen kòd",
        Keys.skill_chef_de_chantier to "Chèf chantye",
        Keys.skill_coffreur_bancheur to "Kofrè",
        Keys.skill_receptionniste to "Resepsyonis",
        Keys.skill_voiturier to "Moun ki pake machin",
        Keys.skill_standardiste to "Operatè telefòn",
        Keys.skill_concierge to "Konsyèj",
        Keys.skill_bagagiste to "Pòtè bagaj",
        Keys.skill_valet_de_chambre to "Sèvitè chanm",
        Keys.skill_gouvernante to "Gouvènant",
        Keys.skill_equipier_detages to "Ajan etaj",
        Keys.skill_bien_etre to "Byennèt",
        Keys.skill_polyvalent to "Polivalan",
        Keys.skill_coursier to "Kouryè",
        Keys.skill_livreur to "Livrè",
        Keys.home_tagline to "Jwenn yon travay nan mwens pase 24 èdtan epi kòmanse jodi a",
        Keys.footer_made_by to "Sit la devlope pa SBH AI DEVELOPMENT",
        Keys.legal_title to "Dokiman",
        Keys.accept_label to "Mwen li epi mwen dakò ak dokiman ki anlè yo",
        Keys.accept_required to "Ou dwe dakò ak dokiman yo pou w kontinye.",
        Keys.doc_terms_title to "SOP – Jesyon ensidan ak konfli",
        Keys.doc_privacy_title to "Politik kont absans ak anilasyon",
        Keys.doc_cookies_title to "Politik peman ak sikilasyon finansye",
        Keys.doc_subscription_title to "Charta angajman mityèl yo",
        Keys.doc_legal_notice_title to "Politik prèv ak konsèvasyon done yo",
        Keys.cancel_subscription to "Anile abònman an",
        Keys.cancel_subscription_confirm_title to "Konfime anilasyon an",
        Keys.cancel_subscription_confirm_body to "Abònman ou ap rete aktif jiska fen peryòd aktyèl la. Ou ka re-abòne nenpòt kilè.",
        Keys.cancel_subscription_confirm_cta to "Anile",
        Keys.cancel_subscription_keep to "Kenbe abònman mwen",
        Keys.cancel_subscription_error to "Nou pa ka anile kounye a. Tanpri eseye ankò pita.",
        Keys.forgot_subtitle to "Antre imel ou, n ap voye yon lyen pou reset modpas ou.",
        Keys.forgot_send_link to "Voye lyen an",
        Keys.forgot_back to "Retounen",
        Keys.forgot_sent_title to "Imel voye",
        Keys.forgot_sent_body to "Tanpri louvri lyen ou resevwa a pou mete yon nouvo modpas.",
        Keys.forgot_continue to "Kontinye",
        Keys.reset_subtitle to "Chwazi yon modpas ki an sekirite.",
        Keys.paywall_title to "Abònman",
        Keys.paywall_headline to "Aksè total nan anyè a",
        Keys.paywall_subtitle to "Debloke tout pwofil yo epi filtre selon konpetans.",
        Keys.paywall_cta to "Chwazi",
        Keys.paywall_plan_monthly_hint to "1 mwa esè gratis, apre sa 9,90€ pa mwa.",
        Keys.paywall_plan_yearly_hint to "99,90€ pa ane (2 mwa gratis).",
        Keys.checkout_success_title to "Peman konfime",
        Keys.checkout_success_headline to "Mèsi!",
        Keys.checkout_success_body to "Abònman ou aktif. Kounye a ou ka wè tout anyè a.",
        Keys.checkout_success_continue to "Kontinye",
        Keys.checkout_success_profile to "Wè pwofil mwen",
        Keys.checkout_cancel_title to "Peman anile",
        Keys.checkout_cancel_headline to "Peman sispann",
        Keys.checkout_cancel_body to "Pa gen peman ki fèt. Ou ka eseye ankò nenpòt lè.",
        Keys.checkout_cancel_back_home to "Retounen lakay",
        Keys.checkout_cancel_profile to "Wè pwofil mwen",
        Keys.paywall_features_title to "Sa ki ladan",
        Keys.paywall_feature_1 to "Aksè san limit nan anyè a",
        Keys.paywall_feature_2 to "Wè pwofil konplè (foto, konpetans, telefòn)",
        Keys.paywall_feature_3 to "Abònman an mete ajou otomatikman",
        Keys.paywall_choose_plan to "Chwazi yon plan",
        Keys.paywall_plan_monthly to "Chak mwa",
        Keys.paywall_plan_yearly to "Chak ane",
        Keys.paywall_not_now to "Pa kounye a",
        Keys.paywall_disclaimer to "Stripe jere peman an. Ou ka anile nenpòt lè.",
        Keys.show_more to "Montre plis",
        Keys.show_less to "Montre mwens",
        Keys.not_connected to "Ou pa konekte.",
        Keys.email_label to "Imèl :",
        Keys.subscription_status to "Estati :",
        Keys.subscription_none to "Pa gen abònman aktif",
        Keys.subscription_active to "Abònman aktif",
        Keys.subscription_expired to "Abònman ekspire",
        Keys.subscription_required_title to "Abònman obligatwa",
        Keys.subscription_required_body to "Ou bezwen yon abònman pou gen aksè ak anyè a.",
        Keys.search_placeholder to "Chèche yon pwofesyonèl",
        Keys.filters to "Filtè",
        Keys.directory_locked_item_title to "Aksè limite",
        Keys.directory_locked_item_body to "Detay yo kache san abònman.",
        Keys.retry to "Reeseye",
        Keys.no_results_title to "Pa gen rezilta",
        Keys.no_results_body to "Pa gen pwofesyonèl ki koresponn ak rechèch la.",
        Keys.clear_filters to "Efase filtè yo",
        Keys.signup_subtitle to "Kreye kont ou epi kòmanse travay rapidman",
        Keys.already_have_account to "Mwen deja gen yon kont",
        Keys.login_subtitle to "Aksede espas eJobin ou gratis",
        Keys.login to "Konekte",
        Keys.loading to "Ap chaje…",
        Keys.show to "Montre",
        Keys.hide to "Kache",
        Keys.error_generic to "Erè",
        Keys.login_title to "Konekte",
        Keys.signup_title to "Enskri",
        Keys.forgot_title to "Mwen bliye modpas",
        Keys.otp_title to "Verifikasyon",
        Keys.reset_title to "Nouvo modpas",
        Keys.email to "Imèl",
        Keys.phone to "Nimewo telefòn",
        Keys.password to "Modpas",
        Keys.password_confirm to "Konfime modpas",
        Keys.name to "Non",
        Keys.create_account to "Kreye yon kont",
        Keys.forgot_password to "Mwen bliye modpas",
        Keys.send_link to "Voye lyen an",
        Keys.sending to "Ap voye...",
        Keys.update_password to "Mete modpas ajou",
        Keys.updating to "Ap mete ajou...",
        Keys.otp_help to "Nou voye yon lyen verifikasyon. Klike sou lyen ki nan imèl la pou kontinye.",
        Keys.otp_i_clicked to "Mwen klike sou lyen an",
        Keys.see_offers to "Gade òf yo",
        Keys.search to "Chèche",
        Keys.available to "Disponib",
        Keys.unavailable to "Pa disponib",
        Keys.extra_title to "Fich pwofil",
        Keys.phone_label to "Telefòn:",
        Keys.profile_title to "Pwofil",
        Keys.logout to "Dekonekte",
        Keys.save to "Sove",
        Keys.saving to "Ap sove...",
        Keys.refresh to "Mizajou",
        Keys.pick_photo to "Chwazi foto",
        Keys.skills_jobs to "Metye / konpetans",
        Keys.required_email to "Imèl obligatwa.",
        Keys.required_name to "Non obligatwa.",
        Keys.invalid_phone to "Nimewo telefòn pa valab.",
        Keys.weak_password to "Modpas la twò kout (min 6).",
        Keys.password_mismatch to "Modpas yo pa menm.",
        Keys.select_one_skill to "Chwazi omwen yon konpetans.",
    )
}